export default __webpack_public_path__ + "static/logo-cp-03e092fee5b02a63fb47d73fe3c25611.png";